export function screen_size(element){    
                element.width = window.innerWidth;
                element.height = window.innerHeight;
                
                window.addEventListener("resize",function(){
                        screen_size(element);
                },false);
    
                window.addEventListener("orientationchange",function(){
                    setTimeout(function(){
                        screen_size(element);
                    },100);
                },false);
            }